import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import CTAButtonPersonalized, { type CtaExposures } from "@/components/custom/CtaButton/CTAButtonPersonalized";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import type { TypeButton, TypeButtonSkeleton, TypeExternalButton, TypeExternalButtonSkeleton } from "@/types/contentful/generated";
type ButtonLike = Entry<TypeButtonSkeleton | TypeExternalButtonSkeleton, undefined, string> | UnresolvedLink<"Entry">;
type ButtonEntry = TypeButton<undefined, string> | TypeExternalButton<undefined, string>;
interface Props {
  heading: string;
  subheading: string;
  cta: ButtonLike[];
  ctaExposures?: CtaExposures;
  reviews?: React.ReactNode;
}
export default function HeroContent(t0) {
  const $ = _c(20);
  const {
    heading,
    subheading,
    cta,
    ctaExposures,
    reviews
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== cta || $[1] !== ctaExposures || $[2] !== heading || $[3] !== subheading) {
    const buttons = cta.map(_temp).filter(_temp2);
    t1 = "flex flex-col gap-3";
    if ($[8] !== heading) {
      t2 = <h1 className="heading-5xl">{heading}</h1>;
      $[8] = heading;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    if ($[10] !== subheading) {
      t3 = <h2 className="text-3xl font-semibold">{subheading}</h2>;
      $[10] = subheading;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t4 = buttons.length > 0 && <div className="flex flex-col gap-3 lg:flex-row">{buttons.map(btn_0 => <CTAButtonPersonalized key={btn_0.sys.id} entry={btn_0} exposures={ctaExposures?.[btn_0.sys.id]} className="w-full lg:w-auto" />)}</div>;
    $[0] = cta;
    $[1] = ctaExposures;
    $[2] = heading;
    $[3] = subheading;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[12] !== reviews) {
    t5 = reviews && <div className="flex justify-center lg:justify-start">{reviews}</div>;
    $[12] = reviews;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp2(b) {
  return b !== null;
}
function _temp(item) {
  const btn = getEntryOfContentType(item, "button");
  const ext = getEntryOfContentType(item, "externalButton");
  return btn ?? ext;
}